import CouponDetails from "../../components/Coupon/CouponDetails";
import PageTitleComponent from "../../components/PageTitle";

export default function CouponDetailsScreen(){
return <div>
    <PageTitleComponent title="Coupon Details" />
    <CouponDetails/>
</div>
}